/**
 * Where a sensor rule's notification opens: the sensor that tripped it
 * (a soil probe gone dry, a tank low). The rule's notify action sends
 * `sensor_rule` with the device's `device_id`, a MAC-like string, hence the
 * encoding. Shared by NotificationBell and usePushNotifications so the two agree.
 */
export function sensorNotificationPath(type: string | undefined, data?: Record<string, string>): string | null {
  if (type === 'sensor_rule' && data?.device_id) {
    return `/irrigation/sensors/${encodeURIComponent(data.device_id)}`;
  }
  return null;
}
